import { useContext } from 'react';
import { LayoutObjectTemplateContext } from '../../context/LayoutObjectTemplateContext';

export const useLayoutObjectTemplateContext = () => {
  const context = useContext(LayoutObjectTemplateContext);

  if (context.isProvided === false) {
    throw new Error(
      'useLayoutObjectTemplateContext must be used within a LayoutObjectTemplateProvider'
    );
  }

  return context;
};
